import { Document } from './document';
import { KeyFieldsFormData } from '../services/document-management/document-management.service';

export interface DocumentFilingState {
  documents: Document[];
  selectedDocumentId: string | null;
  isLoading: boolean;
}

export interface DocumentFormSnapshot {
  documentId: string;
  formValue: KeyFieldsFormData;
  isDirty: boolean;
}

export const EMPTY_FILING_STATE: DocumentFilingState = {
  documents: [],
  selectedDocumentId: null,
  isLoading: false
};
